import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

const useCatalogParams = () => {
  const params: { [key: string]: unknown } = useParams();

  return useMemo(() => {
    const result: { [key: string]: unknown } = {};

    for (const param in params) {
      const currValue = params[param];

      if (
        currValue &&
        typeof currValue === 'string' &&
        (param === 'sportId' || param === 'categoryId' || param === 'tournamentId')
      ) {
        result[param] = parseInt(currValue, 10);
      } else {
        result[param] = params[param];
      }
    }

    return result;
  }, [params]);
};

export default useCatalogParams;
